import { SVGProps } from 'react';

const LoanIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17030_10758)">
      <path
        d="M12.0017 21.5C10.6877 21.5 9.45271 21.2506 8.29658 20.752C7.14043 20.2533 6.13475 19.5765 5.27953 18.7217C4.4243 17.8669 3.74724 16.8616 3.24836 15.706C2.74947 14.5504 2.50003 13.3156 2.50003 12.0017C2.50003 10.6877 2.74936 9.45268 3.24803 8.29655C3.7467 7.1404 4.42345 6.13472 5.27828 5.2795C6.13313 4.42427 7.13837 3.74721 8.29401 3.24833C9.44962 2.74944 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.1331 20.2528 7.13834 20.7517 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5766 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76667 3.99998 7.87501 4.77498 6.32501 6.32498C4.77501 7.87498 4.00001 9.76664 4.00001 12C4.00001 14.2333 4.77501 16.125 6.32501 17.675C7.87501 19.225 9.76667 20 12 20Z"
        fill="#212121"
      />
      <path
        d="M11.4 17.325V16.5102H9V15.288H13.5539C13.6154 15.288 13.6718 15.2618 13.7231 15.2096C13.7744 15.1574 13.8 15.0999 13.8 15.0372V12.6868C13.8 12.6241 13.7744 12.5667 13.7231 12.5144C13.6718 12.4622 13.6154 12.4361 13.5539 12.4361H10.4461C10.042 12.4361 9.69998 12.2935 9.41998 12.0083C9.13999 11.7231 9 11.3747 9 10.9631V8.61272C9 8.20113 9.13999 7.85275 9.41998 7.56757C9.69998 7.28239 10.042 7.13979 10.4461 7.13979H11.4V6.32498H12.6V7.13979H15V8.36198H10.4461C10.3846 8.36198 10.3282 8.3881 10.2769 8.44035C10.2256 8.49258 10.2 8.55003 10.2 8.61272V10.9631C10.2 11.0258 10.2256 11.0833 10.2769 11.1355C10.3282 11.1878 10.3846 11.2139 10.4461 11.2139H13.5539C13.9579 11.2139 14.3 11.3565 14.58 11.6417C14.86 11.9268 15 12.2752 15 12.6868V15.0372C15 15.4488 14.86 15.7972 14.58 16.0824C14.3 16.3676 13.9579 16.5102 13.5539 16.5102H12.6V17.325H11.4Z"
        fill="#212121"
      />
    </g>
    <defs>
      <clipPath id="clip0_17030_10758">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LoanIcon;
